import { useMeContext } from '~/modules/me';

export default ({ showCost, showRevenue }) => {
  const {
    hasViewProjectCostType,
    isRolledUpTaskEstimateCalculationMethodEnabled
  } = useMeContext();

  return {
    showMargin:
      showCost && showRevenue && isRolledUpTaskEstimateCalculationMethodEnabled,
    showHours:
      hasViewProjectCostType ||
      (showRevenue && !isRolledUpTaskEstimateCalculationMethodEnabled)
  };
};
